<template lang="pug">
div
  BriqInput(
    label="Public name"
    placeholder="Name" 
    name="NameExternal"
    data-test-id="name-external"
    v-model="product.NameExternal"
    required
    :disabled="disabled"
    :error="nameExternalError"
    @blur="vuelidate.product.NameExternal.$touch()"
    )
  BriqTextarea(
    label="Description"
    placeholder="Description"
    name="Description"
    v-model="product.Description"
    :disabled="disabled"
    data-test-id="inventory-product-description"
    )
  BriqCheckbox(
    label="Use entered number of people automatically for this extra" 
    name="UseDefaultNumberOfPeople"
    v-model="product.UseDefaultNumberOfPeople"
    :disabled="disabled"
    )
  ImagePicker(label="Image" name="Image" v-model="product.Image" :disabled="disabled")
  BriqRadio.image-alignment(
    label="Horizontal alignment"
    :options="horizontalAlignmentOptions"
    v-model="product.ImageHorizontalAlignment"
    :disabled="disabled"
    )
  BriqRadio.image-alignment(
    label="Vertical alignment"
    :options="verticalAlignmentOptions"
    v-model="product.ImageVerticalAlignment"
    :disabled="disabled"
    )
</template>

<script>
import ImagePicker from '@v/components/ImagePicker.vue'

export default {
  name: 'WebsiteContentFields',
  components: {
    ImagePicker,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    vuelidate: {
      type: Object,
      required: true,
    },
    disabled: Boolean,
    horizontalAlignmentOptions: {
      type: Object,
      required: false,
      default: () => ({
        left: 'Left',
        center: 'Center',
        right: 'Right',
      }),
    },
    verticalAlignmentOptions: {
      type: Object,
      required: false,
      default: () => ({
        top: 'Top',
        middle: 'Middle',
        bottom: 'Bottom',
      }),
    },
    showSecondColumn: Boolean,
  },
  computed: {
    nameExternalError() {
      if (!this.vuelidate.product.NameExternal.$error || this.showSecondColumn) return null
      return 'Please enter a public name'
    },
  },
}
</script>
